
import common_tb from './common_tb';
import common from "../js/common";
import {get, post, postData, postJson} from "../js/http";
import md5 from "js-md5";
import {formatData} from "../js/utils";


/**
 * 获取淘宝的商品列表
 * @param paramsData
 * @param fn
 */
export function getSelectGoods_tb(paramsData, fn) {

    let adzone_id = paramsData.adzone_id;
    if (adzone_id) {
        let randomNum = common.getRandom();
        let _md5 = md5(adzone_id + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_tb.get_select_goods;

        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })

    }
}

/**
 * 获取淘宝的商品列表(参数为json)
 * @param paramsData
 * @param fn
 */
export function getSelectGoodsJson_tb(paramsData, fn) {

    let adzone_id = paramsData.adzone_id;
    if (adzone_id) {
        let randomNum = common.getRandom();
        let _md5 = md5(adzone_id + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        // let param = formatData(paramsData, 'canNull');
        let param = common.copyObj(paramsData)
        this.$log(param)
        let url = common_tb.get_select_goods_by_json;

        // postJson(url, param).then(function (response) {
        //     if (fn) {
        //         fn(response);
        //     }
        // }, function (err) {
        //     fn(err)
        // })

        postJson(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        })

    }
}

/**
 * 获取淘宝商品列表请求参数
 * @returns {{q: string, size: number, has_coupon: boolean, cat: string, adzone_id: string, page: number, sort: string}}
 */
export function getSelectGoods_AllParams_tb() {
    return {
        adzone_id: '110057800181',
        q: '',
        size: 20,
        page: 1,
        sort: '',
        has_coupon: true,
        cat: '-1',
        is_tmall: false,// 商品筛选-是否天猫商品。true表示属于天猫商品，false或不设置表示不限
        need_free_shipment: false,//商品筛选-是否包邮。true表示包邮，false或不设置表示不限
        end_tk_rate: -1,//Number	false	1234	商品筛选-淘客佣金比率上限。如：1234表示12.34%
        start_tk_rate: -1,//Number	false	1234	商品筛选-淘客佣金比率下限。如：1234表示12.34%
        end_price: -1,//Number	false	10	商品筛选-折扣价范围上限。单位：元
        start_price: -1,//Number	false	10	商品筛选-折扣价范围下限。单位：元
    }
}

/**
 * 获取商品详情数据
 * @param paramsData
 * @param fn
 */
export function getSkuDetailData_tb(paramsData, fn) {

    let num_iids = paramsData.num_iids;
    if (num_iids) {
        let randomNum = common.getRandom();
        let _md5 = md5(randomNum + common.key).toLowerCase();
        this.$log("md5 --- " + _md5)
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_tb.get_sku_detail_data + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}


/**
 * 获取淘宝口令
 * @param paramsData
 * @param fn
 */
export function getTbCommand_tb(paramsData, fn) {

    let url = paramsData.url;
    if (url) {
        let randomNum = common.getRandom();
        let _md5 = md5(randomNum + common.key).toLowerCase();
        this.$log("md5 --- " + _md5)
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_tb.get_tb_command + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}


/**
 * 获取订单列表
 * @param paramsData
 * @param fn
 */
export function getOrderList_tb(paramsData, fn) {

    // let url = paramsData.url;
    // if (url) {
    //
    // }
    let randomNum = common.getRandom();
    let _md5 = md5(randomNum + common.key).toLowerCase();
    this.$log("md5 --- " + _md5)
    paramsData.md5 = _md5;
    paramsData.rnum = randomNum;

    let param = formatData(paramsData, 'canNull');
    this.$log(param);
    let url = common_tb.get_order_list + "?" + param;

    get(url).then(function (response) {
        if (fn) {
            fn(response);
        }
    })
}

/**
 * 获取订单列表(完成时间)
 * @param paramsData
 * @param fn
 */
export function getOrderByFinish_tb(paramsData, fn) {

    let pid = paramsData.pid;
    if (pid) {
        let randomNum = common.getRandom();
        let _md5 = md5(pid + randomNum + common.key).toLowerCase();
        this.$log("md5 --- " + _md5)
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_tb.get_order_by_Finish + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}

/**
 * 收入统计接口
 * @param paramsData
 * @param fn
 */
export function getIncometByData_tb(paramsData, fn) {
    // pid:推荐位ID 必须
    // stime:开始时间 默认当天
    // etime:结束时间  默认当天
    let spid = paramsData.pid;
    if (spid) {
        let randomNum = common.getRandom();
        let _md5 = md5(spid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_tb.order_count_new + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 获取每日预估收入的列表
 * @param paramsData
 * @param fn
 */
export function getEverydayCountList_tb(paramsData, fn) {
    // uid:群号 必须
    // stime:开始时间 默认当天
    // etime:结束时间  默认当天
    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_tb.get_everyday_count_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 群下级人数及收入
 * @param paramsData
 * @param fn
 */
export function getLevelCountData_tb(paramsData, fn) {

    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;
        let param = formatData(paramsData);
        let url = common_tb.level_count_data + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 代理通过下级和下下级所能获得的佣金提成的集合
 * @param paramsData
 * @param fn
 */
export function getPidLevelCountList_tb(paramsData, fn) {
    let u_mark = paramsData.u_mark;
    if (u_mark) {
        let randomNum = common.getRandom();
        let _md5 = md5(u_mark + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_tb.pid_level_count_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 用户可提款金额
 * @param paramsData
 * @param fn
 */
export function getUserPayTo_tb(paramsData, fn) {
    let spid = paramsData.uid;
    if (spid) {
        let randomNum = common.getRandom();
        let _md5 = md5(spid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_tb.user_pay_to + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 用户可提款明细
 * @param paramsData
 * @param fn
 */
export function getUserPayList_tb(paramsData, fn) {
    let uid = paramsData.uid;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_tb.user_pay_list + '?' + param;
        get(url).then(function (response) {
            if (fn) {
                fn(response)
            }
        })
    }
}

/**
 * 获取提款纪录
 * @param paramsData
 * @param fn
 */
export function getOrderBySumbit_tb(paramsData, fn) {
    let uid = paramsData.uid;

    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_tb.get_order_by_sumbit;

        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 订单详情下载xls
 * @param paramsData
 * @param fn
 */
export function getOrderByFinishXls_tb(paramsData, fn) {
    let pid = paramsData.pid;
    let stime = paramsData.stime;

    if (pid && stime) {
        let randomNum = common.getRandom();
        let _md5 = md5(pid + stime + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);

        let url = common_tb.get_order_by_finish_xls;

        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        }, function (err) {
            fn(err)
        })
    }
}

/**
 * 提交提款
 * @param paramsData
 * @param fn
 */
export function getUserSubmit_tb(paramsData, fn) {
    let uid = paramsData.uid;
    let truename = paramsData.u_truename;
    let account = paramsData.u_account;
    if (uid) {
        let randomNum = common.getRandom();
        let _md5 = md5(uid + truename + account + randomNum + common.key).toLowerCase();
        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData);
        this.$log(param)
        let url = common_tb.user_submit;
        post(url, param).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}

/**
 * 获取系统配置
 * @param paramsData
 * @param fn
 */
export function getSubConfig_tb(fn) {

    let randomNum = common.getRandom();
    let _md5 = md5(randomNum + common.key).toLowerCase();
    let paramsData = {
        md5: _md5,
        rnum: randomNum
    };

    let param = formatData(paramsData);
    this.$log("getSubConfig param = " + param)
    let url = common_tb.sub_config + '?' + param;
    get(url).then(function (response) {
        if (fn) {
            fn(response)
        }
    })
}

/**
 * 获取商品详情数据
 * @param paramsData
 * @param fn
 */
export function getElemeData(paramsData, fn) {

    let relation_id = paramsData.relation_id;
    if (relation_id) {
        let randomNum = common.getRandom();
        let _md5 = md5(randomNum + common.key).toLowerCase();

        paramsData.md5 = _md5;
        paramsData.rnum = randomNum;

        let param = formatData(paramsData, 'canNull');
        this.$log(param);
        let url = common_tb.get_eleme_data + "?" + param;

        get(url).then(function (response) {
            if (fn) {
                fn(response);
            }
        })
    }
}
